<template>
  <div class="container">
    <div v-if="isMobile" class="mobileRoot">
      <a
        class="download"
        href="https://game-sport.s3-ap-east-1.amazonaws.com/app/com.aig.app888b-v1.apk"
        download="888b-mainpageAPK.apk"
      >
        <img src="../assets/sport7/pc-down-btn-bg.png" />
      </a>
    </div>
    <div v-else class="content">
      <a
        class="download"
        href="https://game-sport.s3-ap-east-1.amazonaws.com/app/com.aig.app888b-v1.apk"
        download="888b-mainpageAPK.apk"
      >
        <img src="../assets/sport7/down-btn-bg.png" />
      </a>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import "../../static/js/initRem";

import { isMobile } from "../utils/tools";
import { captcha } from "@/mixins/captcha";
const check = {};

export default {
  name: "Sport7",
  mixins: [captcha],
  data() {
    return {
      swiperMobileVisible: false,
      isMobile: isMobile()
    };
  },
  mounted() {
    this.swiperMobileVisible = isMobile() && window.innerWidth > 360;
    const OnRezie = window.onresize;

    window.onresize = () => {
      OnRezie();
      this.isMobile = isMobile();
      this.swiperMobileVisible = this.isMobile && window.innerWidth > 360;
    };
  },
  methods: {}
};
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #ffffff;
}

// 通用文件
.content,
.mobileRoot {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.download {
  img {
    width: 100%;
  }
}
// 电脑端
.content {
  background: url("../assets/sport7/bg.jpg") no-repeat center/cover;
  .download {
    position: absolute;
    bottom: 0.2rem;
    left: 0;
    right: 0;
    margin: auto;
    width: 2.9rem;
    animation-duration: 3s;
    animation-name: slidein;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    &:hover {
      //animation-direction: none;
    }
  }
}

@keyframes slidein {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

// 手机端
.mobileRoot {
  background: url("../assets/sport7/mobile-bg.jpg") no-repeat center/cover;
  .download {
    position: absolute;
    top: 5.9rem;
    left: 0;
    right: 0;
    margin: auto;
    animation-duration: 3s;
    animation-name: slidein;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
}

@media only screen and (min-width: 1000px) {
  // 电脑端
  .content {
    background: url("../assets/sport7/bg.jpg") no-repeat center/cover;
    .download {
      position: absolute;
      bottom: 51px;
      left: 0;
      right: 0;
      margin: auto;
      width: 471px;
      animation-duration: 3s;
      animation-name: slidein;
      animation-iteration-count: infinite;
      animation-direction: alternate;
      &:hover {
       // animation-direction: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sport7.vue